import { render } from "./AddWish.vue?vue&type=template&id=b0608d7e"
import script from "./AddWish.vue?vue&type=script&lang=ts"
export * from "./AddWish.vue?vue&type=script&lang=ts"

import "./AddWish.vue?vue&type=style&index=0&id=b0608d7e&lang=scss"
script.render = render

export default script